import { Controller, Control, FieldError } from 'react-hook-form';
import { useCallback, useEffect, useRef, useState } from "react";
import { ReactComponent as EyeClosedIcon } from "../../../../assets/svg/icons/eyeClosed.svg";
import { ReactComponent as EyeOpenIcon } from "../../../../assets/svg/icons/eye.svg";
import InputMask from "react-input-mask";
import "./styles.css";

type StateProps = "Success" | "Error" | "Normal";

interface HookFormTextInputProps {
  name: string;
  label: string;
  type?: "text" | "password" | "tel" | "email" | "number";
  mask?: string | (string | RegExp)[];
  regex?: RegExp;
  maxLength?: number;
  max?: number;
  control: Control<any>;
  error?: FieldError;
  onAnywhereChanges?: () => void;
  id?: string;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
}

export function HookFormTextInputWithLabel({
  name,
  label,
  type = "text",
  mask,
  regex,
  maxLength,
  max,
  control,
  error,
  onAnywhereChanges,
  id,
  className,
  disabled,
  placeholder,
  ...rest
}: HookFormTextInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [errorField, setErrorField] = useState<string>("");
  const [errorState, setErrorState] = useState<StateProps>("Normal");
  const [show, setShow] = useState<boolean>(false);

  const onChangeAnywhereInput = useCallback(() => {
    if (onAnywhereChanges) onAnywhereChanges();
  }, [onAnywhereChanges]);

  function handlePassword() {
    setShow((prevState) => !prevState);
  }

  useEffect(() => {
    setErrorState(() => (error ? "Error" : "Normal"));
    if (error && error.message !== " ") {
      setErrorField(() => error.message || "");
    } else {
      setErrorField("");
    }
  }, [error]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <>
          <div className={`textInput-label__container inputStatus${errorState}`}>
            <div className="textInput-label__content">
              <label>{label}</label>
              {/* Input de senha com toggle show/hide */}
              {type === "password" ? (
                <InputMask
                  {...field}
                  {...rest}
                  ref={inputRef as any}
                  type={show ? "text" : "password"}
                  value={field.value || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    const cleanValue = regex ? value.match(regex)?.join('') || '' : value;
                    field.onChange(cleanValue);
                    onChangeAnywhereInput();
                  }}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  maxLength={maxLength}
                  mask=""
                  alwaysShowMask={false}
                  //@ts-ignore
                  maskChar={null}
                />
              ) : type === "tel" ? (
                <InputMask
                  {...field}
                  {...rest}
                  ref={inputRef as any}
                  mask={mask as string | (string | RegExp)[]}
                  alwaysShowMask={false}
                  autoComplete="tel"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  //@ts-ignore
                  maskChar={null}
                />
              ) : (
                <input
                  {...field}
                  {...rest}
                  className={`textInput`}
                  ref={inputRef as any}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              )}
            </div>
            {type === "password" && (
              <button type="button" onClick={handlePassword} id={`toggleHide-${name}`}>
                {show ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </button>
            )}
          </div>
          {errorField && (
            <small className="textInputwithlabel__error animation__fadeIn" id={`error-${name}`}>{errorField}</small>
          )}
        </>
      )}
    />
  );
}
